/** @var {Array} ACCREDITATION_TYPES */
var ACCREDITATION_TYPES = [
  "hmrCertificate",
  "ahpraCertificate",
  "piPlCertificate",
];

/**
 * Handle display and validation of AP Verification
 */
const $inject = [
  "$stateParams",
  "$timeout",
  "$uibModal",
  "$state",
  "CommonData",
  "RegistrationService",
  "Upload"
];

class VerificationController {

  constructor(
    $stateParams,
    $timeout,
    $uibModal,
    $state,
    CommonData,
    RegistrationService,
    UploadService
  ) {

    this.debug = false;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.timeout = $timeout;

    this.registrationService = RegistrationService;
    this.uploadService = UploadService;

    this.code = $stateParams.code;

    this.pharmacist = {
      country: "Australia",
    };

    this.states = CommonData.STATES;

    this.calendarStatus = {opened: false};

    this.longLoad = false;

    this.progress = null;

    this.validationMessage = [];
    this.submissionError = null;

    this.initFiles();

  }

  /**
   * Initialise file variables
   */
  initFiles() {
    this.files = {};
    this.viewValues = {};
    for (var i = 0; i < ACCREDITATION_TYPES.length; i++) {
      this.files[ACCREDITATION_TYPES[i]] = {};
      this.viewValues[ACCREDITATION_TYPES[i]] = null;
    }
  }

  /**
   * Are files being uploaded ?
   * @returns {Boolean}
   */
  hasFiles() {
    for (var i = 0; i < ACCREDITATION_TYPES.length; i++) {
      if (this.files[ACCREDITATION_TYPES[i]] && typeof this.files[ACCREDITATION_TYPES[i]].size != "undefined") {
        return true;
      }
    }
    return false;
  }

  /**
   * Release Date
   * @todo this should probably be a directive
   */
  openCalendar($event) {
    this.calendarStatus = {opened: true};
  }

  /**
   * Format the date appropriately
   * @param   date
   *
   * @returns {String}
   */
  formatDate(date) {
    var day = date.getDate() < 10? "0" + date.getDate().toString(): date.getDate().toString();
    var numMonth = (date.getMonth() + 1);
    var month = numMonth < 10? "0" + numMonth.toString(): numMonth.toString();
    var year = date.getFullYear().toString();
    return year + "-" + month + "-" + day;
  }

  /**
   * Update the model for the expiration date
   * @param date
   */
  selectDate(date) {
    this.pharmacist.expirationDate = this.formatDate(date);
  }

  /**
   * Verify the user
   * @param form
   */
  verify(form) {

    this.submitted = true;
    this.verificationForm = form;
    this.verificationForm.validationMessage = null;

    var self = this;

    //set to true if loading is taking a while (10 secs)
    self.longLoad = false;

    var timer = self.timeout(function () {
      self.longLoad = true;
    }, 10000);

    var stopTimer = function () {
      self.timeout.cancel(timer);
      self.longLoad = false;
    };

    var handleSuccess = function (response) {
      if (!response.data.error) {
        self.loading = false;
        self.showModal();
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      self.loading = false;
      self.validationMessage = response.data.message;
      self.verificationForm.validationMessage = response.data.message;

      stopTimer();

      if (typeof response.data.message == "string") {
        self.submissionError = response.data.message;
      }
      else {
        for (var element in response.data.message) {
          if (self.verificationForm[element]) {
            self.verificationForm[element].$setValidity("server", false);
          }
        }
      }

      stopTimer();

    };

    var handleProgress = function (event) {
      if (self.hasFiles()) {
        self.progress = parseInt(100.00 * event.loaded / event.total);
      }
    };

    if (form.$valid) {
      self.loading = true;
      self.uploadService.upload({
        url: "/app/complete",
        data: {
          pharmacist: self.pharmacist,
          code: self.code,
          files: self.files,
        },
      }).then(handleSuccess, handleError, handleProgress);
    }
    else {
      stopTimer();
    }

  }

  showModal() {
    var self = this;

    var closeModal = function () {
      self.$state.go("app.login");
    };

    //Show success modal
    var modalInstance = self.$uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: "accountModal.html",
      controller: "AccountModalController",
      controllerAs: "accountCtrl",
      resolve: {
        items: function () {
          return {
            title: "Account Successfully Setup",
            msg: null, //Set in templates partials modal
            type: "verify",
            closeEvent: closeModal,
          };
        },
      },
    });
  }

  /**
   * Get file name for the view
   * @param type
   * @param $file
   */
  displayName(type, $file) {
    this.viewValues[type] = $file.name;
  }

}

VerificationController.$inject = $inject;

export default VerificationController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/account/controllers/verification.controller.js
 **/